/**
 * PATH: apps/ai/src/components/MobileBottomNav.tsx
 * PURPOSE: Mobile bottom navigation bar for AI Hub
 * 
 * Shows on small/medium screens (lg:hidden) with quick access to key pages.
 * Uses react-router-dom NavLink for active state handling.
 */

import { NavLink } from 'react-router-dom';
import { 
  MessageSquare, 
  FileText, 
  FileSearch, 
  Settings 
} from 'lucide-react';
import { cn } from '../lib/utils';

const navItems = [
  { icon: MessageSquare, label: 'Chat', href: '/' },
  { icon: FileText, label: 'Reports', href: '/reports' },
  { icon: FileSearch, label: 'Docs', href: '/extraction' },
  { icon: Settings, label: 'Settings', href: '/settings' },
];

export function MobileBottomNav() {
  return (
    <nav className="fixed bottom-0 inset-x-0 lg:hidden bg-card border-t border-border z-50 pb-safe">
      <div className="flex justify-around">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.href}
              to={item.href}
              end={item.href === '/'}
              className={({ isActive }) => cn(
                'flex flex-col items-center py-2 px-3 min-w-[64px] transition-colors',
                isActive 
                  ? 'text-primary' 
                  : 'text-muted-foreground hover:text-foreground'
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="text-xs mt-1 font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}

export default MobileBottomNav;

